import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
  card: {
    borderRadius: '9px !important',
    height: '83vh',
    boxShadow: 'none !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '81vh !important',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      height: '84vh !important',
    },
  },
  card2: {
    borderRadius: '9px !important',
    boxShadow: 'none !important',
  },
  cardContent: {
    padding: '14px',
  },
  title: {
    textAlign: 'left',
    fontSize: '15px',
    fontWeight: '500 !important',
    marginBottom: '10px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12px !important',
    },
  },
  divider: {
    borderBottom: '1px solid #BFCEFF',
    marginBottom: '10px',
  },
  description: {
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: '400',
    marginTop: '20px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  gridContainer: {
    margin: '5px',
    marginTop: '10px !important',
  },
  gridItem: {
    border: '1px solid #BFCEFF',
    borderRadius: '12px !important',
    height: '148px',
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      height: '15vh !important',
    },
  },
  gridItem1: {
    borderRadius: '12px !important',
    backgroundColor: '#F6F8FB',
  },
  gridItemContent: {
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
  },
  gridItemContent1: {
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    height: '10vh',
  },
  gridItemImage: {
    width: '100%',
    height: 'auto',
    borderRadius: '12px 12px 0 0 !important',
    marginBottom: '12px',
  },
  gridItemTextContent: {
    marginBottom: '12px',
  },
  gridItemTitle: {
    textAlign: 'left',
    fontSize: '21px',
    fontWeight: '600 !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '15px !important',
    },
  },
  gridItemTitle1: {
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: '500 !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  gridItemText: {
    textAlign: 'left',
    fontSize: '10.5px',
    fontWeight: '400',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '9.5px !important',
    },
  },
  gridItemFooter: {
    padding: '12px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  gridItemFooterText: {
    fontSize: '10.5px',
    fontWeight: '500 !important',
  },
  secondaryCard: {
    borderRadius: '9px !important',
    boxShadow: 'none !important',
    height: '39vh',
    [theme.breakpoints.up('xxl')]: {
      height: '31.5vh',
    },
  },
  secondaryCardContent: {
    margin: '20px',
  },
  secondaryCardTitle: {
    justifyContent: 'space-between',
    display: 'flex',
  },
  secondaryCardTitleText: {
    fontSize: '15px',
    fontWeight: '500 !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12px !important',
    },
  },
  secondaryCardImage: {
    width: '143.25px',
    height: '170.25px',
  },
  scrollableContent: {
    height: '50vh',
    marginTop: '20px',
    overflow: 'hidden',
    '@media (min-width: 1270px) and (max-width: 1290px)': {
      height: '40vh !important',
    },
  },
  scrollableCard: {
    borderRadius: '9px !important',
    boxShadow: 'none !important',
    height: '49vh',
    overflow: 'hidden',
    '@media (min-width: 1270px) and (max-width: 1279px)': {
      height: '40vh !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '38vh !important',
    },
    '@media (min-width: 1920px) and (max-width: 2000px)': {
      height: '50vh !important',
    },
  },
  scrollableCardContent: {
    padding: '14px',
  },
  card1: {
    borderRadius: '9px !important',
    height: '83vh',
    boxShadow: 'none !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '81vh !important',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      height: '84vh !important',
    },
  },
  cardContent1: {
    padding: '14px',
  },
  sectionTitle: {
    textAlign: 'left',
    fontSize: '15px',
    fontWeight: '500 !important',
    marginBottom: '10px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12px !important',
    },
  },
  sectionTitle1: {
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: '500 !important',
    marginBottom: '10px !important',
  },
  sectionDivider: {
    borderBottom: '1px solid #E5E6EA',
  },
  description1: {
    textAlign: 'left',
    fontSize: '16px',
    fontWeight: '400',
    marginTop: '20px',
  },
  gridContainer1: {
    margin: '5px',
    marginTop: '20px',
  },
  itemContainer: {
    padding: '15px',
  },
  container: {
    height: '70vh',
  },
  itemText: {
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: '400',
    marginBottom: '10px !important',
    paddingLeft: '15px',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  itemDivider: {
    borderBottom: '1px solid #B2B3B7',
  },
  scholarshipContainer: {
    padding: '20px',
    marginBottom: '7vh',
  },
  scholarshipText: {
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: 400,
  },
  scholarshipCard: {
    padding: '20px',
    backgroundColor: '#F6F8FB !important',
    borderRadius: '9px !important',
  },
  scholarshipAmount: {
    fontSize: '12px',
    fontWeight: '600 !important',
    textAlign: 'left',
  },

  scholarshipDescription: {
    fontSize: '10.5px',
    fontWeight: '400',
    textAlign: 'left',
  },
  buttonContainer: {
    display: 'flex',
    float: 'right',
    marginBottom: '20px',
    justifyContent: 'flex-end',
  },
  button: {
    width: '120px',
    marginRight: '20px',
    boxShadow: 'none !important',
  },
  InputField: {
    width: '336px !important',
    borderRadius: '25px !important',
  },
  InputField1: {
    width: '216px !important',
    borderRadius: '25px !important',
  },
  Dialogtitle: {
    fontSize: '20px',
    fontWeight: '500 !important',
    marginLeft: '12px !important',
    marginTop: '10px !important',
  },
  Inputtext: {
    fontSize: '12px',
    marginLeft: '5px !important',
    marginBottom: '2px !important',
    fontWeight: '500 !important',
    margin: '0px',
  },
  donorBox: {
    height: '39vh',
    [theme.breakpoints.up('xxl')]: {
      height: '31.5vh',
    },
  },
  scolarshipBox: {
    height: '40vh',
    [theme.breakpoints.up('xxl')]: {
      height: '48vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '35vh',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      height: '55vh',
    },
    '@media (min-width: 1536px) and (max-width: 1636px)': {
      height: '45.5vh',
    },
  },
  createText: {
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
}));
